import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import StickyFooterVendor from 'core/modules/StickyFooterVendor/StickyFooterVendor';
import ModalRoot from 'core/modules/Modal/ModalRoot';

function Root() {
  return (
    <>
      <StickyFooterVendor />
      <ModalRoot />
    </>
  );
}

export default (props) => <ComponentErrorBoundary><Root {...props} /></ComponentErrorBoundary>;
